var html = require('choo/html')
var raw = require('choo/html/raw')
var Nanocomponent = require('nanocomponent')
var css = 0
var articleList = require('../tmpl/articleList.js')

var prefix = ((require('sheetify/insert')("@import url(\"https://fonts.googleapis.com/css?family=Lato|Lora|Cousine\");\n._734f6314 {\n  -webkit-padding-start: 0;\n  list-style: none;\n  font-family: Cousine, monospace;\n  -webkit-padding-start: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column; }\n  ._734f6314 li {\n    margin: 0 auto 1.25rem;\n    width: 45%; }\n    ._734f6314 li + li {\n      padding-top: 20px;\n      border-top: 1px solid #eee; }\n    ._734f6314 li a {\n      font-size: 1.3125rem;\n      font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif;\n      color: inherit;\n      font-weight: bold; }\n      ._734f6314 li a mark {\n        font-size: 1.1875rem;\n        float: right;\n        font-weight: 300;\n        background: none;\n        color: #aeaeae; }\n") || true) && "_734f6314")

class Component extends Nanocomponent {
  constructor () {
    super()
  }

  createElement (state, emit) {
    return html`
      <ul class='${prefix} ${state.isDark ? "isDark" : ""}'>
        ${raw(articleList(state))}
      </ul>
    `
  }

  update () {
    return true
  }
}

function clickButton (state, emit) {
  return () => {
    emit('')
  }
}

module.exports = new Component()
